import styles from "./ItemActions.module.scss";
import {Dropdown} from "react-bootstrap";
import clsx from "clsx";
import React from "react";

export const ItemActions = ({actions}) => {
  return <div className={styles.actions}>
    <Dropdown align="end">
      <Dropdown.Toggle id="dropdown-custom-components" as={CustomToggle}>
        <span className="material-icons">more_vert</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {actions.map((action, index) => {
          if (action.type === "item") {
            return <Dropdown.Item key={index} className={styles.option} onClick={action.onClick}>
              <span className={clsx(styles.optionIcon, "material-icons")}>{action.icon}</span>
              {action.label}
            </Dropdown.Item>;
          } else if (action.type === "divider") {
            return <Dropdown.Divider key={index}/>;
          } else {
            return null;
          }
        })}
      </Dropdown.Menu>
    </Dropdown>
  </div>;
};

const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
  <span className={clsx(styles.optionsIcon, "material-icons")} ref={ref} onClick={(e) => {
    e.preventDefault();
    onClick(e);
  }}>more_vert</span>
));